import { useCallback } from 'react';
import type {
  PersonalMeetingData,
  UseLobbyMessageHandlerParams,
  UseLobbyMessageHandlerReturn,
} from '../types';

const useLobbyMessageHandler = ({
  updateMeetingData,
}: UseLobbyMessageHandlerParams): UseLobbyMessageHandlerReturn => {
  const handleLobbyMessageCommit = useCallback(
    (value: string) => {
      updateMeetingData(
        (prev: PersonalMeetingData) => ({
          ...prev,
          lobbyMessage: value,
        }),
        { field: 'lobbyMessage', successMessage: 'Lobby message updated' },
      );
    },
    [updateMeetingData],
  );

  return {
    handleLobbyMessageCommit,
  };
};

export default useLobbyMessageHandler;
